module.exports = __webpack_public_path__ + "img/loading.30964553.png";